import { ValidatorBase } from './ValidatorBase'
import { StringUtils } from '../../../Utils/StringUtils';

export class RangeValidator extends ValidatorBase {

    public constructor(message: string, data: string) {
        super(message, data);
    }

    public validate(value: string, messages: string[]) {
        let intValue = parseInt(value);
        let from = parseInt(this._data.split('-')[0]);
        let to = parseInt(this._data.split('-')[1]);
        if (intValue < from || intValue > to) {
            let msg = StringUtils.isNullOrEmpty(this._message) ? `Value must be in range ${from}-${to}.` : this._message;
            messages.push(msg);
        }
    }

}


/** WEBPACK FOOTER **
 ** ./Typescript/Components/ConfigurationPanel/Validators/RangeValidator.ts
 **/